"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colMeasureLocalId = void 0;
// (C) 2007-2021 GoodData Corporation
var tableDescriptorTypes_1 = require("./tableDescriptorTypes");
/**
 * Returns localId of measure whose values the provided column contains. For convenience, any type of column
 * can be provided and undefined is returned if the column is not of type that contains measure values.
 *
 * @param col - column descriptor
 */
function colMeasureLocalId(col) {
    return tableDescriptorTypes_1.isSeriesCol(col)
        ? col.seriesDescriptor.measureDescriptor.measureHeaderItem.localIdentifier
        : undefined;
}
exports.colMeasureLocalId = colMeasureLocalId;
//# sourceMappingURL=colAccessors.js.map